import React, { useState, useEffect } from "react";
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from "react-native";
import Modal from '@material-ui/core/Modal';
import Feather from '@expo/vector-icons/Feather';
import { tenantActions } from "../../../redux/tenant.actions";
import { useDispatch } from "react-redux";
import { showErrorToast, showSuccesToast } from "../../helpers";
import InfowaningBox from "./infowaningBox";
import DropDownPicker from "../../../../../components/picker/DropDownPicker.web";
import STRINGS from "../../../redux/strings";
import getPlatformType from "../../../../../helpers/helpers";

const EditTenantModal = (props) => {
  const {
    onClose,
    showModal,
    addedUsers,
    flowId,
    CurrIndex
  } = props;

  // Initialize form with empty values or existing data
  const initialFormData = {
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    contactNumber: "",
    postcode: "",
    address: "",
    CurrIndex
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  console.log("CurrIndex", CurrIndex)

  useEffect(() => {
    console.log("addedUsers", addedUsers)
    console.log("CurrIndex", CurrIndex)
    if (addedUsers?.length) {
      let userDetails = addedUsers[CurrIndex]?.app_user?.user;
      setFormData(
        {
          ...initialFormData,
          title: userDetails?.title? userDetails?.title:"" ,
          firstName: userDetails?.first_name?userDetails?.first_name:"",
          lastName:  userDetails?.last_name?userDetails?.last_name:"",
          email: userDetails?.email?userDetails?.email:"",
          confirmEmail:  userDetails?.email?userDetails?.email:"",
          contactNumber: userDetails?.contact_number? userDetails?.contact_number:"",
          postcode:  userDetails?.postcode?userDetails?.postcode:"",
          address: userDetails?.address? userDetails?.address:"",
          is_lead: addedUsers[CurrIndex]?.is_lead,
        }
      )
    }
  }, [CurrIndex]);

  const validate = () => {
    let newErrors = {};
  
    if (!formData.title || !formData.title.trim() || formData.title === 'Select here' || formData.title === '0') {
      newErrors.title = "Title is required";
    }
  
    if (!formData.firstName?.trim())
      newErrors.firstName = "First name is required";
  
    if (!formData.lastName?.trim())
      newErrors.lastName = "Last name is required";
  
    if (!formData.email?.trim())
      newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email";
  
    if (formData.confirmEmail !== formData.email)
      newErrors.confirmEmail = "Emails must match";
  
    if (!formData.contactNumber?.trim())
      newErrors.contactNumber = "Contact number is required";
  
    if (!formData.postcode?.trim())
      newErrors.postcode = "Postcode is required";
  
    if (!formData.address?.trim())
      newErrors.address = "Address is required";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
        showErrorToast('Invalid Email');
        return;
      }
      const tenantData = {
        address: formData.address,
        confirm_email: formData.confirmEmail,
        contact_number: formData.contactNumber,
        email: formData.email,
        first_name: formData.firstName,
        isLeadTeanant: formData.is_lead,
        last_name: formData.lastName,
        postcode: formData.postcode,
        title: formData.title,
      };

      let finalArr;
      finalArr = addedUsers.map(user =>
        user?.app_user?.user?.email === formData.email
          ? {
            ...user,
            app_user: { user: { ...tenantData } },
            edit_this_tenant: true,
          }
          : user
      );


      dispatch(tenantActions.saveTeanantDetails(
        { tenants: finalArr, flow_id: flowId },
        (data) => {
          setFormData(initialFormData);
          onClose();
          showSuccesToast(`Tenant updated successfully!`);
          dispatch(tenantActions.getFlowInfo(flowId));
        }
      ));
    }

  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: undefined }));
    }
  };

  return (
    <Modal
      open={showModal}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <div>
        <View style={styles.overlay}>
          <View style={styles.modalContainer}>
            <View style={styles.contentContainer}>
              <Text style={styles.header}>
                {'Edit Tenant'}
              </Text>


              <View style={styles.formGroup}>
                <DropDownPicker
                  items={STRINGS.OPENFLOW_TITLES.map((ITEM) => ({
                    value: ITEM,
                    label: ITEM
                  }))}
                  title={'Title *'}
                  error={Boolean(errors.title)}
                  defaultValue={formData.title}
                  onChangeItem={(e) => handleInputChange('title', e.value)}
                />
                {errors.title && <Text style={styles.error}>{errors.title}</Text>}
              </View>

              <View style={styles.row}>
                <View style={[styles.formGroup, styles.halfWidth]}>
                  <TextInput
                    style={styles.input}
                    placeholder="First Name"
                    value={formData.firstName}
                    onChangeText={(text) => handleInputChange('firstName', text)}
                  />
                  {errors.firstName && <Text style={styles.error}>{errors.firstName}</Text>}
                </View>

                <View style={[styles.formGroup, styles.halfWidth]}>
                  <TextInput
                    style={styles.input}
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChangeText={(text) => handleInputChange('lastName', text)}
                  />
                  {errors.lastName && <Text style={styles.error}>{errors.lastName}</Text>}
                </View>
              </View>

              <View style={styles.formGroup}>
                <TextInput
                  style={[styles.input,{backgroundColor:"#EBEBE4"}]}
                  placeholder="Email"
                  keyboardType="email-address"
                  editable={false}
                  value={formData.email}
                  onChangeText={(text) => handleInputChange('email', text)}
                />
                {errors.email && <Text style={styles.error}>{errors.email}</Text>}
              </View>

              <View style={styles.formGroup}>
                <TextInput
                  style={[styles.input,{backgroundColor:"#EBEBE4"}]}
                  placeholder="Confirm Email"
                  keyboardType="email-address"
                  editable={false}
                  value={formData.confirmEmail}
                  onChangeText={(text) => handleInputChange('confirmEmail', text)}
                />
                {errors.confirmEmail && <Text style={styles.error}>{errors.confirmEmail}</Text>}
              </View>

              <View style={styles.formGroup}>
                <TextInput
                  style={styles.input}
                  placeholder="Contact Number"
                  keyboardType="phone-pad"
                  value={formData.contactNumber}
                  onChangeText={(text) => handleInputChange('contactNumber', text.replace(/[^0-9]/g, ""))}
                />
                {errors.contactNumber && <Text style={styles.error}>{errors.contactNumber}</Text>}
              </View>


                <View style={[styles.formGroup]}>
                  <TextInput
                    style={styles.input}
                    placeholder="Postcode"
                    value={formData.postcode}
                    onChangeText={(text) => handleInputChange('postcode', text)}
                  />
                  {errors.postcode && <Text style={styles.error}>{errors.postcode}</Text>}
                </View>


              <View style={styles.formGroup}>
                <TextInput
                  style={[styles.input, styles.textArea]}
                  placeholder="Address"
                  multiline
                  numberOfLines={3}
                  value={formData.address}
                  onChangeText={(text) => handleInputChange('address', text)}
                />
                {errors.address && <Text style={styles.error}>{errors.address}</Text>}
              </View>

              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  style={[styles.button, styles.cancelButton]}
                  onPress={onClose}
                >
                  <Text style={styles.buttonText}>Cancel</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[styles.button, styles.submitButton]}
                  onPress={handleSubmit}
                >
                  <Text style={styles.buttonText}>
                    {'Update Tenant'}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </div>
    </Modal>
  );
};
const layoutType = getPlatformType()
const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    width: layoutType=="web"? "90%":300,
    maxWidth: 600,
    backgroundColor: "white",
    padding: 20,
    borderRadius: 10,
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  contentContainer: {
    flexDirection: "column",
    flex: 1,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 5,
    elevation: 3,
    padding: 14
  },
  header: {
    fontSize: 22,
    fontWeight: "bold",
    marginBottom: 20,
    textAlign: "center",
    color: '#333',
  },
  formGroup: {
    marginBottom: 15,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  halfWidth: {
    width: '48%',
  },
  input: {
    borderWidth: 1,
    borderColor: "#ddd",
    padding: 12,
    borderRadius: 6,
    fontSize: 16,
    backgroundColor: 'white',
  },
  textArea: {
    height: 80,
    textAlignVertical: 'top',
  },
  error: {
    color: "red",
    fontSize: 12,
    marginTop: 5,
  },
  buttonContainer: {
    flexDirection: layoutType=="phone"?"column": "row",
    justifyContent: "space-between",
    marginTop: 20,

  },
  button: {
    padding: 12,
    borderRadius: 6,
    flex: 1,
    alignItems: "center",
    justifyContent: 'center',
  },
  cancelButton: {
    backgroundColor: "#ccc",
    marginRight: layoutType=="phone"? 0:10,
  },
  submitButton: {
    backgroundColor: "#d63384",
    marginLeft: layoutType=="phone"? 0:10,
    marginTop:layoutType=="phone"? 10:0,

  },
  buttonText: {
    color: "white",
    fontWeight: "bold",
    fontSize: 16,
  },
});

export default EditTenantModal;